<template>
  <div class="container">
    <div class="filter-container">
      <el-input
          v-model="searchValue"
          placeholder="请输入ISBN"
          style="width: 220px; margin-right: 10px;"
          class="filter-item"
          size="small"
          clearable
          @keyup.enter.native="handleFilter"
      />
      <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleFilter"
      >搜索</el-button>
    </div>
    <el-table
        v-loading="listLoading"
        :data="list"
        row-key="ISBN"
        border
        fit
        highlight-current-row
        style="width: 100%;"
    >
      <el-table-column label="ISBN" align="center">
        <template v-slot="{ row }">
          <span>{{ row.ISBN || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标题" align="center">
        <template v-slot="{ row }">
          <span>{{ row.Title || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="作者" align="center">
        <template v-slot="{ row }">
          <span>{{ row.Author || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="分类号" align="center">
        <template v-slot="{ row }">
          <span>{{ row.Class || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面" align="center" width="100">
        <template v-slot="{ row }">
          <el-image
              v-if="row.Cover"
              style="width: 60px; height: 80px"
              :src="row.Cover"
              fit="cover"
              lazy
              :preview-src-list="[row.Cover]"
              preview-teleported
          >
            <template #error>
              <img
                  style="width: 60px; height: 80px; object-fit: cover"
                  :src="defaultCover"
                  alt="封面"
              />
            </template>
          </el-image>
          <img
              v-else
              style="width: 60px; height: 80px; object-fit: cover"
              :src="defaultCover"
              alt="封面"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="120">
        <template v-slot="{ row }">
          <el-button type="primary" size="mini" @click="openEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 图书纠错弹窗（与 ErrorManager 共用） -->
    <book-error-correction-dialog
        v-model:visible="dialogVisible"
        :isbn="currentIsbn"
        @success="getList"
    />

    <div style="margin-top: 50px; text-align: right;">
      <el-pagination
          background
          :total="total"
          :current-page="listQuery.Page"
          :page-size="listQuery.PerPage"
          :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
          layout="prev,pager,next,jumper,sizes,total"
          @size-change="pageSizeChange"
          @current-change="currPageChange"
      />
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/utils/constants";
import BookErrorCorrectionDialog from "@/components/BookErrorCorrectionDialog.vue";

export default {
  name: "isbnBookInfo",
  components: { BookErrorCorrectionDialog },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        Page: 1,
        PerPage: 20,
      },
      searchValue: "",
      defaultCover: require("../../assets/img/defaultBook.png"),
      dialogVisible: false,
      currentIsbn: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const params = {
        OrderBy: "id",
        Sort: "-1",
        Page: this.listQuery.Page,
        PerPage: this.listQuery.PerPage,
      };
      if (this.searchValue) {
        params.Search = { ISBN: this.searchValue };
      } else {
        params.Search = {};
      }
      this.listLoading = true;
      this.$axios({
        url: BASE_URL + "isbnbookinfo/search",
        method: "post",
        data: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.list = res.data.msg;
          this.total = res.data.total;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.Page = 1;
      this.getList();
    },
    // 打开编辑（图书纠错）弹窗
    openEdit(row) {
      this.currentIsbn = row.ISBN;
      this.dialogVisible = true;
    },
    pageSizeChange(PerPage) {
      this.listQuery.PerPage = PerPage;
      this.getList();
    },
    currPageChange(Page) {
      this.listQuery.Page = Page;
      this.getList();
    },
  },
};
</script>

<style scoped>
/* 解除 .container 的滚动拦截，使 sticky 相对外层 .content 滚动容器生效 */
.container {
  overflow: visible;
}
/* 中和 el-table 根元素的 overflow:hidden（否则它会成为不可滚动的滚动容器，导致表头无处可粘） */
:deep(.el-table) {
  overflow: visible;
}
/* 表格表头吸顶：页面滚动时表头固定，数据行正常滚动（类似 Excel 冻结首行） */
:deep(.el-table__header-wrapper) {
  position: sticky;
  top: 0;
  z-index: 10;
}
</style>
